module.exports = __webpack_public_path__ + "img/logo-fivenomics.6fafcc7a.png";